export default __webpack_public_path__ + "static/media/Avatar-22.43e27c8b.svg";